import { render, staticRenderFns } from "./ship_sync.vue?vue&type=template&id=4aed9f6f&scoped=true"
import script from "./ship_sync.vue?vue&type=script&lang=js"
export * from "./ship_sync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed9f6f",
  null
  
)

export default component.exports